export default "__VITE_PUBLIC_ASSET__c7aab319__"